import clsx from 'clsx';
import styles from './dateRangeField.module.scss';
import { ChangeEventHandler, ReactNode } from 'react';
import { BuilderFieldLabel, BuilderFieldLabelProps } from '../../wrappers/label/builderFieldLabel.component';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { BuilderFieldError } from '../../wrappers/error/builderFieldError.component';
import { AppTextInput } from 'uikit/inputs';
import { dateToInputString, maxDateOrNull, minDateOrNull } from './date-helper';

export type DateRangeProps = {
  labelProps: BuilderFieldLabelProps;
  disabled?: boolean;
  errorText?: string;
  startDateErrorText?: string;
  endDateErrorText?: string;
  onStartChange?: ChangeEventHandler<HTMLInputElement>;
  onEndChange?: ChangeEventHandler<HTMLInputElement>;
  startDate?: string;
  endDate?: string;
  minStartDate?: string;
  minEndDate?: string;
  maxStartDate?: string;
  maxEndDate?: string;
  tooltip?: ReactNode;
  testId?: string;
};

export const AppDateRangeField = (props: DateRangeProps) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.UiKit.Inputs.DateRange');
  const {
    onStartChange,
    onEndChange,
    startDate,
    endDate,
    labelProps,
    disabled,
    errorText,
    startDateErrorText,
    endDateErrorText,
    testId,
  } = props;

  const maxStartDate = minDateOrNull(props.maxStartDate, endDate) ?? undefined;
  const minEndDate = maxDateOrNull(props.minEndDate, startDate) ?? undefined;

  return (
    <div className={clsx(styles.container)} data-test-id={testId}>
      <BuilderFieldError errors={errorText || startDateErrorText || endDateErrorText}>
        <BuilderFieldLabel disabled={disabled} {...labelProps}>
          <div className={styles.wrapContainer}>
            <AppTextInput
              placeholder={t('From')}
              type={'date'}
              disabled={disabled}
              onChange={onStartChange}
              value={startDate}
              min={props.minStartDate}
              max={dateToInputString(maxStartDate, false)}
              invalid={!!startDateErrorText || !!errorText}
              className={styles.inputContainer}
            />

            <span className={styles.divider}>—</span>

            <AppTextInput
              placeholder={t('Until')}
              type={'date'}
              disabled={disabled}
              value={endDate}
              onChange={onEndChange}
              min={dateToInputString(minEndDate, false)}
              max={props.maxEndDate}
              invalid={!!endDateErrorText || !!errorText}
              className={styles.inputContainer}
            />
          </div>
        </BuilderFieldLabel>
      </BuilderFieldError>
    </div>
  );
};
